import { LinkTo } from "@ember/routing";
import avatar from "discourse/helpers/avatar";
import concatClass from "discourse/helpers/concat-class";
import { and } from "discourse/truth-helpers";
import { i18n } from "discourse-i18n";
import CirclesPrivacyStatus from "../../components/circles/privacy-status";

const CircleAbout = <template>
  <div class="circles-about-wrapper circles-tab-content">
    <section class="circles-about-section circles-about-privacy">
      <h3 class="circles-about-section-title">
        {{i18n "discourse_circles.circle.about.title"}}
      </h3>
      <CirclesPrivacyStatus @model={{@model}} />
    </section>

    {{#if @controller.featuredMembers}}
      <section class="circles-about-section circles-about-members">
        <div class="circles-about-section-title-group">
          <h3 class="circles-about-section-title">
            {{i18n
              "discourse_circles.circle.about.members"
              count=@model.member_group.user_count
            }}
          </h3>
          <LinkTo @route="circle.members">
            {{i18n "discourse_circles.view_all"}}
          </LinkTo>
        </div>
        <div>
          {{#each @controller.featuredMembers as |user|}}
            <a
              href="/u/{{user.username}}"
              data-user-card={{user.username}}
              class="avatar-link"
            >
              {{avatar user imageSize="small"}}
            </a>
          {{/each}}
        </div>
      </section>
    {{/if}}

    <section class="circles-about-section circles-about-activity">
      <h3 class="circles-about-section-title">
        {{i18n "discourse_circles.circle.about.activity"}}
      </h3>
      <ul class="circles-about-activity-stats">
        {{#each @controller.activityStats as |stat|}}
          <li class="circles-about-activity-stat-item">{{stat}}</li>
        {{/each}}
      </ul>
      <p class="circles-about-created">
        {{i18n
          "discourse_circles.circle.about.created"
          date=@controller.createdAt
        }}
      </p>
    </section>

    {{#each @model.customFields as |field|}}
      {{#if (and field.value field.displayOnAboutPage)}}
        <section
          class={{concatClass
            "circles-about-section circles-about-custom-field"
            field.type
          }}
          data-custom-field-type={{field.type}}
        >
          <h3 class="circles-about-section-title">
            {{field.name}}
          </h3>
          <p class="circles-about-custom-field-value">
            {{field.value}}
          </p>
        </section>
      {{/if}}
    {{/each}}
  </div>
</template>;

export default CircleAbout;
